import { StyleSheet } from 'aphrodite';

export const styleSheet = StyleSheet.create({
	container: {
		textAlign: 'center',
	},
	image: {
		display: 'inline-block',
		marginTop: 20,
		position: 'relative',
	},
	loading: {
		/**
		 * Got these numbers from the svg and the size of the loading spinner (blue square offsetX) - (blue square width /
		 * 2) + (loading spinner width / 2)
		 */
		left: 167 - 74 / 2 + 76 / 2,
		position: 'absolute',
		top: 0,
		transform: 'scale(0.8, 0.8)',
		transformOrigin: '50% 50%',
	},
	title: {
		color: '#4E6A7D',
		fontSize: 14,
		letterSpacing: 3.5,
		textTransform: 'uppercase',
	},
});
